<template>

    <m-edit1/>

    <m-products-502 v-bind='{...{"perPage":65,"productCardName":"mProductCard208","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item","showCategoriesSlider":false,"offerType":"number","offerStatus":false,"relatedCurrentCategory":true,"showKeywords":false,"smCardName":"mProductCard208","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"mix it web","cardLink":false,"infinityLoading":false,"chooseCategoriesFromTop":false,"cardLinkTarget":"_self","productStoresDirectFilter":null,"orderFilterProp":["brand","feature","category","search","quantity","store","price"],"singleCategory":"\u0645\u062d\u0635\u0648\u0644\u0627\u062a_\u0627\u0646\u06af\u0644\u06cc\u0633\u06cc","categoryCard":"mCategoryCardUnKnow300","secondCategoryCard":"mCategoryCardUnKnow301","swiperPerViewSM":2,"swiperPerViewMD":4,"swiperPerViewLG":5},...{}}' :style='""' class="mt-3 m-content-wrapper-fr" ></m-products-502>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mProducts502 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products502/Products502';

export default {
    name: 'HomeView',
    components: {mEdit1, mProducts502 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
